var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('van-empty',{staticClass:"custom-image",attrs:{"description":_vm.text}},[_c('img',{style:({ width: _vm.width, height: _vm.height }),attrs:{"slot":"image","src":_vm.getUrl},slot:"image"}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }